import React, { useEffect, useState } from "react";
import { adminApi } from "../../lib/adminApi";
import { Loader2, ScrollText } from "lucide-react";

const AdminActivity = ({ onAuthError }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    adminApi.get("/admin/activity?limit=200").then((r) => setRows(r.data)).catch(onAuthError);
  }, []);
  if (!rows) return <div className="flex justify-center py-20 text-slate-500"><Loader2 className="w-5 h-5 animate-spin" /></div>;
  return (
    <div data-testid="admin-activity">
      {rows.length === 0 ? (
        <div className="rounded-2xl bg-white border border-slate-200 shadow-[0_1px_2px_rgba(15,23,42,0.04),0_10px_30px_-24px_rgba(15,23,42,0.22)] p-10 text-center text-slate-500">
          <ScrollText className="w-8 h-8 mx-auto mb-2 opacity-50" />
          No admin actions recorded yet.
        </div>
      ) : (
        <div className="rounded-2xl bg-white border border-slate-200 shadow-[0_1px_2px_rgba(15,23,42,0.04),0_10px_30px_-24px_rgba(15,23,42,0.22)] overflow-hidden">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[10px] font-mono uppercase tracking-wider text-slate-500 border-b border-slate-200">
              <th className="px-4 py-3">When</th><th className="px-4 py-3">Admin</th><th className="px-4 py-3">Action</th><th className="px-4 py-3">Target / Details</th>
            </tr></thead>
            <tbody>
              {rows.map((e, i) => (
                <tr key={`${e.at}-${i}`} className="border-b border-slate-200" data-testid={`activity-row-${i}`}>
                  <td className="px-4 py-3 text-slate-500 whitespace-nowrap">{new Date(e.at).toLocaleString()}</td>
                  <td className="px-4 py-3 text-slate-500">{e.admin_email}</td>
                  <td className="px-4 py-3 text-slate-800 capitalize">{e.action}</td>
                  <td className="px-4 py-3 text-slate-500">{[e.target, e.details].filter(Boolean).join(" · ") || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminActivity;
